import { memo, useEffect, useRef, useState } from 'react'

type SectionVisibilityDetectorProps = { className?: string; children: React.ReactNode }

const SectionVisibilityDetector: React.FC<SectionVisibilityDetectorProps> = memo(({ className, children }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const sectionRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(entry.target) // Unobserve the target to avoid unnecessary callbacks
        }
      },
      { threshold: 0.1 },
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current) // Ensure cleanup on component unmount
      }
      observer.disconnect()
    }
  }, [])

  return (
    <div ref={sectionRef} className={className} style={{ minHeight: '50px' }}>
      {isVisible ? children : null}
    </div>
  )
})

export default SectionVisibilityDetector